import { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useNavigationBlocker } from 'src/hooks/block';
import { setHasUnsavedChanges, setIsEdit } from 'src/redux/slices/formSlice';
import { resetMeetingMinutesState } from 'src/redux/slices/meetingMinutesSlice';

const UnsavedChangesModal = () => {
  const hasUnsavedChanges = useSelector((state) => state.form.hasUnsavedChanges);
  const isEdit = useSelector((state) => state.form.isEdit);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [pendingRetry, setPendingRetry] = useState(null);
  const [pendingLocation, setPendingLocation] = useState(null);
  //   console.log('pendingLocation', pendingLocation);

  useNavigationBlocker(
    (tx) => {
      if (hasUnsavedChanges && isEdit) {
        setShowModal(true);
        setPendingRetry(() => tx.retry);
        setPendingLocation(tx.location);
      } else {
        tx.retry(); // Just go if nothing to block
      }
    },
    hasUnsavedChanges && isEdit // Activate only when needed
  );

  const handleLeave = () => {
    setShowModal(false);
    dispatch(setIsEdit(false));
    dispatch(setHasUnsavedChanges(false));

    if (pendingRetry) {
      pendingRetry();
    }

    setTimeout(() => {
      // If pendingLocation has 'pathname' directly
      if (pendingLocation?.pathname) {
        navigate(pendingLocation.pathname);
      }
      // Else if pendingLocation has a 'location' property with pathname
      else if (pendingLocation?.location?.pathname) {
        navigate(pendingLocation.location.pathname);
      }
    }, 3000);
  };

  const handleStay = () => {
    setShowModal(false);
    setPendingRetry(null);
  };

  return (
    <Modal open={showModal} onClose={handleStay}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          width: 400,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Unsaved Changes
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You have unsaved changes. Are you sure you want to leave this page?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="contained" color="error" onClick={handleLeave}>
            Leave
          </Button>
          <Button variant="outlined" onClick={handleStay}>
            Stay
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UnsavedChangesModal;
